import { render, staticRenderFns } from "./DetailsTab.vue?vue&type=template&id=18ced1dc&scoped=true&"
import script from "./DetailsTab.vue?vue&type=script&lang=js&"
export * from "./DetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTab.vue?vue&type=style&index=0&id=18ced1dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ced1dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
